const studentDisplayName = (studentName) => {
    let displayName = studentName || "Student";
    if (studentName) {
        const nameArray = studentName?.split(", ");
        if (nameArray.length === 2) {
            displayName = `${nameArray[1]} ${nameArray[0]}`;
        }
    }

    return displayName;
};

export default studentDisplayName;
